import React, { useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { FaTimes } from 'react-icons/fa';

import './StudentForm.css';
import { api, request } from '../../../../utilities';

export default function StudentForm(props) {

  const [studyAreasList, setStudyAreasList] = useState([])
  const [techFeeList, setTechFeeList] = useState([])
  const { residency, classification, studyArea, credits, classification_specific, techDropdown } = props.data

  useEffect(() => {
    //Component mounted
    const controller = new AbortController()
    const signal = controller.signal
    request(api('view/study-area'), signal, 'GET', undefined, { id: classification, })
      .then(res => res.json())
      .then(obj => {
        setStudyAreasList(obj)
        if (obj.length === 1) setChar("studyArea", obj[0]["id"])
      })
      .catch(e => console.error(e))

    request(api('view/tech'), signal, 'GET', undefined, { id: studyArea, })
      .then(res => res.json())
      .then(obj => {
        setTechFeeList(obj)
        if (obj.length === 1) setChar("techDropdown", obj[0]["id"])
      })
      .catch(e => console.error(e))


    return () => {
      //Component unmounted
      controller.abort()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classification, studyArea]) // Empty dependency array to run the effect

  const setChar = (key, value, del_key = undefined) => {
    let ans = { ...props.data }
    if (value && ans[key] !== value) {
      ans[key] = value
      if (del_key !== undefined) {
        if (Array.isArray(del_key)) del_key.forEach(e => delete ans[e])
        else delete ans[del_key]
      }
      props.changeState(ans)
    }
  }
  const studyAreaDropdown = () => {
    return (
      <select disabled={studyAreasList.length === 0} onChange={(e) => setChar("studyArea", e.target.value, "techDropdown")} value={studyArea} >
        <option value="">{(studyAreasList.length === 0) ? 'Select a Classification Status to see Areas of Study' : 'Please select an Area of Study'}</option>
        {studyAreasList.map(area => (<option key={area.id} value={area.id} >{area.name}</option>))}
      </select>
    )
  }
  const techFeeDropdown = () => {
    return (
      <select disabled={techFeeList.length === 0} onChange={(e) => setChar("techDropdown", e.target.value)} value={techDropdown} >
        <option value="">{(techFeeList.length === 0) ? 'Select an Area of Study to see available tech fees' : 'Please select a Tech Fee'}</option>
        {techFeeList.map(area => (<option key={area.id} value={area.id} >{area.name}</option>))}
      </select>
    )
  }
  const classificationSpecificDropdownGraduate = () => {
    return (
      <select disabled={classification_specific === ""} onChange={(e) => setChar("classification_specific", e.target.value)} value={classification_specific} >
        <option value="">{'Please select a specific classification for graduate'}</option>
        <option value={"first-year"} >Graduate 1st Year</option>
        <option value={"others"} >Graduate Other Years</option>
      </select>
    )
  }
  const classificationSpecificDropdownVetMed = () => {
    return (
      <select disabled={classification_specific === ""} onChange={(e) => setChar("classification_specific", e.target.value)} value={classification_specific} >
        <option value="">{'Please select a specific classification for VetMed'}</option>
        <option value={"first-year"} >VetMed 1st Year</option>
        <option value={"others"} >VetMed 2nd - 3rd Years</option>
      </select>
    )
  }

  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Student Information {(props.invalid) ? <FaTimes style={{ marginLeft: 'auto', marginTop: "5px", color: "red" }} size={30} /> : null}</Accordion.Header>
        <Accordion.Body>
          <div className="entry">
            <label htmlFor="residency" className='mt-2 me-2'>Residency Status</label>
            <span id="residency" className="btn-group" role='group'>
              <button type="button" className={residency === 1 ? "btn active" : "btn"} onClick={() => setChar("residency", 1)}>Iowa Resident</button>
              <button type="button" className={residency === 2 ? "btn active" : "btn"} onClick={() => setChar("residency", 2)}>Non-Iowa Resident</button>
            </span>
          </div>
          <hr></hr>
          <div className="entry btn-group" role='group'>
            <label htmlFor="credits" className='me-3'>Credits</label>
            <span id="credits">
              {
                [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1]
                  .map((e) => (<button key={e} type="button" className={credits === e ? "btn active text-center" : "btn text-wrap"} onClick={() => setChar("credits", e)}>{e}</button>))
              }
            </span>
          </div>
          <div style={{ fontSize: "11px", textAlign: "left",}}>
            For undergrads, anything above 12 credits equals pricing for 12 credits. And for graduates, anything above 9 credits equals price for 9 credits.
          </div>
          <hr></hr>
          <div className="entry btn-group" role='group'>
            <label htmlFor="classification">Classification Status</label>
            <span id="classification">
              <button type="button" className={classification === 1 ? "btn active" : "btn"} onClick={() => setChar("classification", 1, ["studyArea", "classification_specific"])}>Freshman</button>
              <button type="button" className={classification === 6 ? "btn active" : "btn "} onClick={() => setChar("classification", 6, ["studyArea", "classification_specific"])}>Sophomore</button>
              <button type="button" className={classification === 2 ? "btn active" : "btn "} onClick={() => setChar("classification", 2, ["studyArea", "classification_specific"])}>Junior / Senior</button>
              <button type="button" className={classification === 3 ? "btn active" : "btn "} onClick={() => setChar("classification", 3, ["studyArea", "classification_specific"])}>Graduate</button>
              <button type="button" className={classification === 4 ? "btn active" : "btn "} onClick={() => setChar("classification", 4, ["studyArea", "classification_specific"])}>Vet Med Years 1-3</button>
              <button type="button" className={classification === 5 ? "btn active" : "btn "} onClick={() => setChar("classification", 5, ["studyArea", "classification_specific"])}>Vet Med Year 4</button>
            </span>
          </div>

          {
            classification === 3
              ?
              <>
                <hr />
                <div className="dropdown">
                  <label htmlFor="study-area">Graduate specific</label>
                  <span id="study-area" name="study-area">
                    {classificationSpecificDropdownGraduate()}
                  </span>
                </div>
              </>
              :
              null
          }
          {
            classification === 4
              ?
              <>
                <hr />
                <div className="dropdown">
                  <label htmlFor="study-area">VetMed specific</label>
                  <span id="study-area" name="study-area">
                    {classificationSpecificDropdownVetMed()}
                  </span>
                </div>
              </>
              :
              null
          }

          <hr></hr>
          <div className='container'>
            <div className="row align-items-center mb-3">
              <div className="col-md-3">
                <label htmlFor="study-area" className="form-label">Area of Study</label>
              </div>
              <div className="col-md-9">
                <span id="study-area" name="study-area" className='dropdown'>
                  {studyAreaDropdown()}
                </span>
              </div>
            </div>
            <hr />
            <div className="row align-items-center mb-3">
              <div className="col-md-3">
                <label htmlFor="study-area" className="form-label">Tech Fee</label>
              </div>
              <div className="col-md-9">
                <span id="study-area" name="study-area" className='dropdown'>
                  {techFeeDropdown()}
                </span>
              </div>
            </div>
          </div>

        </Accordion.Body>
      </Accordion.Item>
    </Accordion >
  )
}